import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import {Link} from "react-router-dom";
import Form from 'react-bootstrap/Form';
// import 'bootstrap/dist/css/bootstrap.min.css';
import '../Login/login.css'
const SignupForm = () => {

    const [formData, setFormData] = useState({ 
        username:"",
        usermail:"",
        pass1:"",
        pass2:""})

    const [errors,setErrors] = useState({})

    const submitHandler = (e)=>{

        e.preventDefault()
      
        let errors = {}

        if(formData.username.trim()===""){
            errors.username = "Username Required!"
        }

        else if(formData.username.trim().length<5){
            errors.username = "Username Must be 5 Chars or More!"
        }

        if(formData.usermail.trim()===""){
            errors.usermail = "User Mail Required!"
        }
        else if(formData.usermail.trim()===""){
            errors.usermail = "Email must contain  '@' symbol"
        }

        if(formData.pass1.trim()===""){
            errors.pass1 = "Password is Required"
        }
        else if(formData.pass1.trim().length<8){
            errors.pass1 = "Password should contain atleast 8 characters!"
        }
        if(formData.pass2.trim()===""){
            errors.pass2 = "Password Should Match"
        }
        setErrors(errors)
    }

    const handleChange = (e)=>{
        const {name,value} = e.target
        setFormData({...formData,[name]:value})
    }

  return (

    <div className='card2'>
        <div className="container">
        <h2>Signup</h2>
        <Form onSubmit={submitHandler} className='w-100 '>
            <Form.Group className="mb-3">
                <Form.Control type="text" placeholder="Enter username" name='username' onChange={handleChange} />
                {
                    (errors.username)&&<p className='error-color'>{errors.username}</p>
                }
            </Form.Group>
            <Form.Group className="mb-3" >
               
                <Form.Control type="text" placeholder="Enter email" name='usermail' onChange={handleChange}  />
                {
                    (errors.usermail)&&<p className='error-color'>{errors.usermail}</p>
                }
            </Form.Group>

            <Form.Group className="mb-3">
                
                <Form.Control type="password" placeholder="Password" name='pass1' onChange={handleChange}/>
                {
                    (errors.pass1)&&<p className='error-color'>{errors.pass1}</p>
                }
            </Form.Group>
            <Form.Group className="mb-3" >
               
                <Form.Control type="password" placeholder="Confirm password..." name='pass2' onChange={handleChange} />
           {
            (errors.pass2)&&<p className='error-color'>{errors.pass2}</p>
           }
            </Form.Group>
            <Button variant="primary" type="submit" >
                Submit
            </Button>

            <div className='footer'>
            <p>Already Have an Account..?</p>
            <Link to="/login">Login</Link>
            </div>
        </Form> 
        </div>
    </div>
  )
}

export default SignupForm